module.exports = __webpack_public_path__ + "static/img/repast03.fe80e6fd.jpg";